import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSpinnerGap = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		children: /* @__PURE__ */ _jsx("path", { d: "M8 2v2M14 8h-2M12.245 12.245l-1.413-1.413M8 14v-2M3.758 12.245l1.412-1.413M2 8h2M3.758 3.756 5.17 5.168" })
	})
});
export default SvgSpinnerGap;
